import { render } from "./AgendaDate.vue?vue&type=template&id=229e36d2"
import script from "./AgendaDate.vue?vue&type=script&lang=js"
export * from "./AgendaDate.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__